class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    if (this.querySelector('.facets__form-vertical')) {
      closingAccordions('.facets__disclosure-vertical');
    }

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.openDetails = Array.from(document.querySelectorAll('details[open]')).map(details => details.id);
    FacetFiltersForm.openExpandableContainers = Array.from(document.querySelectorAll('expandable-container.open')).map(expandable => expandable.id);
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      })
      .finally(() => {
        const menuDrawer = document.querySelector('menu-drawer');
        if (menuDrawer && menuDrawer.classList.contains('mobile-facets__wrapper')) {
          setTimeout(() => {
            closingAccordions('.mobile-facets__dropdown details');
          });
        }
        const collectionGrid = document.querySelector('#ProductGridContainer');
        if (collectionGrid) {
          collectionGrid.disconnectedCallback();
          collectionGrid.init();
        }
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
    const collectionGrid = document.querySelector('#ProductGridContainer');
    if (collectionGrid) {
      collectionGrid.disconnectedCallback();
      collectionGrid.init();
    }
  }

  static renderProductGridContainer(html) {
    const newProductGrid = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('product-grid');
    const productGrid = document.getElementById('product-grid');
    productGrid.innerHTML = newProductGrid.innerHTML;

    if (newProductGrid.classList.contains('product-grid--no-filters')) {
      productGrid.classList.add('product-grid--no-filters')
    } else {
      productGrid.classList.remove('product-grid--no-filters')
    }

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const newHeaderElement = parsedHTML.querySelector('.collection__header__heading');
    if (newHeaderElement) {
      const currentHeaderElement = document.querySelector('.collection__header__heading');
      if (currentHeaderElement) {
        currentHeaderElement.innerHTML = newHeaderElement.innerHTML;
      }
    }

    document.getElementById('ProductGridContainer').querySelector('.collection').classList.remove('loading');
    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const countFacets = new DOMParser().parseFromString(html, 'text/html').querySelector('.facets-container .product-count');
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerFacets = document.querySelector('.facets-container .product-count');
    if (!count) return;
    if (container) {
      container.innerHTML = count.innerHTML;
      container.classList.remove('loading');
    }
    if (containerDesktop) {
      containerDesktop.innerHTML = count.innerHTML;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
    if (!countFacets) return;
    if (containerFacets) {
      containerFacets.innerHTML = countFacets.innerHTML;
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    FacetFiltersForm.openDetails?.forEach(id => {
      const detailsElement = document.getElementById(id);
      if (detailsElement) {
        detailsElement.setAttribute('open', true);
      }
    });
    FacetFiltersForm.openExpandableContainers?.forEach(id => {
      const expandableContainerElement = document.getElementById(id);
      if (expandableContainerElement) {
        expandableContainerElement.classList.add('open');
      }
    });

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);
        if (newElementToActivate) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      '.mobile-facets__open',
      '.mobile-facets__count',
      '.sorting',
      '.mobile-facets__main',
      '#FacetsWrapperDesktop',
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      if (selector == '.mobile-facets__main' || selector == '#FacetsWrapperDesktop') {
        Array.from(document.querySelectorAll(`${selector} details`)).forEach((detail) => {
          const newDetail = html.getElementById(detail.id);
          if (newDetail) {
            if (detail.hasAttribute('open') == true) {
              newDetail.setAttribute('open', true);
              if (!document.querySelector(selector).classList.contains('mobile-facets__dropdown'))
                newDetail.classList.add('menu-opening');
            } else newDetail.removeAttribute('open');
          }
        });
      }
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('ProductGridContainer').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const collectionProductGrid = document.querySelector('#CollectionProductGrid');
    window.scrollTo({ top: collectionProductGrid ? collectionProductGrid.offsetTop - 100 : 0, behavior: 'smooth' });
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.minRange = this.querySelector('.range__input--min');
    this.maxRange = this.querySelector('.range__input--max');
    this.debouncedOnRangeChange = debounce((event) => {
      this.onRangeChange(event);
    }, 700);
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('input', (event) => {
        this.debouncedOnRangeChange(event);
        this.adjustInputSize(event.target);
      });
    });
    this.setMinAndMaxValues();
    this.setUpRange();
    this.setUpRangeValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.target);
    this.setMinAndMaxValues();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    if (form) form.dispatchEvent(new Event('input', { bubbles: true }));
  }

  setUpRangeValues() {
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const minValue = radio.getAttribute('data-gte');
        const maxValue = radio.getAttribute('data-lte');
        const form = this.closest('facet-filters-form')?.querySelector('form');
        const minInput = form.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = form.querySelector('input[name="filter.v.price.lte"]');

        if (minValue && minInput) minInput.value = minValue;
        if (maxValue && maxInput) maxInput.value = maxValue;

        form.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }

  setMinAndMaxValues() {
    const min = this.querySelector('.price-range__input--min input');
    const max = this.querySelector('.price-range__input--max input');
    if (!min || !max) return;

    if (max.value) min.setAttribute('data-max', max.value);
    if (min.value) max.setAttribute('data-min', min.value);
    if (min.value === '') max.setAttribute('data-min', min.getAttribute('data-min'));
    if (max.value === '') min.setAttribute('data-max', max.getAttribute('data-max'));
  }

  setUpRangeValues() {
    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        const minValue = radio.getAttribute('data-gte');
        const maxValue = radio.getAttribute('data-lte');
        const form = this.closest('facet-filters-form')?.querySelector('form');
        const minInput = form.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = form.querySelector('input[name="filter.v.price.lte"]');

        if (minValue && minInput) minInput.value = minValue;
        if (maxValue && maxInput) maxInput.value = maxValue;

        form.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (input.value == '') return;

    if (value < min) input.value = min;
    if (value > max) input.value = max;

    this.adjustInputSize(input);
  }

  adjustInputSize(input) {
    const group = input.closest('.price-range__input__group');
    if (!group) return;
    const width = group.querySelector('.price-range__input__width');
    if (width) width.innerHTML = input.value;
  }

  setUpRange() {
    if (!this.minRange || !this.maxRange) return;

    this.minRange.addEventListener('input', this.onRangeInputChange.bind(this));
    this.maxRange.addEventListener('input', this.onRangeInputChange.bind(this));
  }

  onRangeInputChange(event) {
    const input = event.currentTarget;
    if (!input) return;

    let target = null;
    if (input == this.minRange) {
      target = this.querySelector('.price-range__input--min input');
      if (+input.value >= +this.maxRange.value) input.value = +this.maxRange.value;
    } else {
      target = this.querySelector('.price-range__input--max input');
      if (+input.value <= +this.minRange.value) input.value = +this.minRange.value;
    }

    if (target) {
      target.value = input.value;
      this.adjustInputSize(target);
    }

    this.updateRangeFill();
  }

  updateRangeFill() {
    this.style.setProperty('--range-min', `${(this.minRange.value / +this.dataset.max) * 100}%`);
    this.style.setProperty('--range-max', `${(this.maxRange.value / +this.dataset.max) * 100}%`);

    this.minRange.style.setProperty('--x-offset', `${(this.minRange.value / +this.dataset.max) * 100 - 50}%`);
    this.maxRange.style.setProperty('--x-offset', `${(this.maxRange.value / +this.dataset.max) * 100 - 50}%`);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const collectionProductGrid = document.querySelector('#CollectionProductGrid');
    window.scrollTo({ top: collectionProductGrid ? collectionProductGrid.offsetTop - 100 : 0, behavior: 'smooth' });
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
    const filtersDrawer = document.querySelector('menu-drawer details[open]');
    document.body.classList.remove('overflow-hidden', 'overflow-hidden-drawer')
    if (filtersDrawer) {
      filtersDrawer.classList.remove('menu-opening')
      filtersDrawer.removeAttribute('open');
    }
  }
}

customElements.define('facet-remove', FacetRemove);